import { palette } from './palette';
import {
  CONTENT_BAND_INSET,
  TABLET_DOWN,
  MOBILE_DOWN,
  HERO_TABLET_IMAGE,
  HERO_MOBILE_IMAGE,
  HEADER_OFFSET,
  HERO_MOBILE_UNIT,
  WAVE_BAND,
  WAVE_DOME,
} from './layout';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .logo-image': {
      width: '151px !important',
      height: '80px !important',
    },
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
        '& .login-logo-container':{
          '& a img': {
          height: '10% !important',
          }
        }
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
    '& .top-bar-logo-container': {
      height: '40% !important',
    },
    '& .menu-item, & .header-phone-link': {
      fontFamily: 'Inter Display',
      fontSize: '14px !important',
      lineHeight: '18px !important',
      letterSpacing: '-0.28px !important',
      fontWeight: '400 !important',
    },
    '& .MuiButton-root': {
      fontFamily: 'Inter Display',
      fontSize: '16px !important',
      lineHeight: '20px !important',
      letterSpacing: '-0.32px !important',
      fontWeight: '400 !important',
    },
    '& .topbar-listitem': {
      padding: '0px 10px !important',
    }
  },

  '.group-parent-container': {
    '& .normal-text': {
      fontWeight: 400,
      fontFamily: "'Editorial New' !important",
      fontSize: '64px !important',
      lineHeight: '72px !important',
      letterSpacing: '-0.64px !important',
      '@media screen and (max-width: 900px)': {
        fontSize: '50px !important',
        lineHeight: '50px !important',
        letterSpacing: '-1.0px !important',
      },
    },
    '& .hero-home-button': {
      color: palette.text.highlight,
      borderColor: palette.text.highlight,

      '&:hover': {
        borderColor: palette.text.highlight,
      },
    },

    '& .savings-hero-section, & .checkout-hero-section, & .plan-selection-section, & .faq-hero-section, & .dashboard-hero-section, & .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
    {
      position: 'relative',
      overflow: 'hidden',
      background: `${palette.background.innerHero} !important`,
      backgroundSize: 'cover',
      paddingBlock: '168px 80px !important',
      maxHeight: 'none !important',
      height: 'auto !important',

      '& .section': {
        paddingBlock: '0 !important',
      },
      '& .section-header': {
        maxWidth: '1280px !important',
        marginInline: 'auto !important',
        marginBlock: '0 !important',
        paddingBlock: '0 !important',
      },
      '& .section-header__title-wrapper': {
        padding: '0 !important',
      },
      '& .section-header__subtitle-wrapper': {
        padding: '8px 0 0 !important',
      },
      '& .hero-header-title': {
        fontFamily: "'Editorial New' !important",
        fontSize: '36px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.04em !important',
        fontWeight: '500 !important',
        '@media screen and (max-width: 700px)': {
          fontSize: '30px !important',
          lineHeight: '36px !important',
        },
      },
      '& .hero-header-subtitle': {
        fontFamily: "'Inter Display' !important",
        fontSize: '18px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.03em !important',
        fontWeight: '400 !important',
        '@media screen and (max-width: 700px)': {
          fontSize: '16px !important',
          lineHeight: '22px !important',
        },
      },

      '& .header-container': {
        marginTop: '32px !important',
        width: '100% !important',
        marginInline: '0 !important',
        marginBottom: '0 !important',
        gap: 20,
        justifyContent: 'center',
      },
      '& .header-container > *': {
        margin: '0 !important',
        padding: '0 !important',
      },
      '& .hero-link-button, & .hero-home-button': {
        minWidth: '144px !important',
        width: '144px !important',
        minHeight: 'unset !important',
        borderRadius: '6px !important',
        paddingBlock: '12px !important',
        boxShadow: 'none !important',
        textTransform: 'none',
        fontFamily: 'Inter Display',
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.02em !important',
        fontWeight: '400 !important',
        whiteSpace: 'nowrap',
        paddingInline: '12px !important',
        '& .MuiButton-label': {
          lineHeight: '20px !important',
          whiteSpace: 'nowrap',
        },
      },
      '& .hero-link-button': {
        backgroundColor: `${palette.surface.buttonTertiary} !important`,
        color: `${palette.text.heading} !important`,
        border: 'none !important',
        '&:hover': {
          backgroundColor: `${palette.background.ribbon} !important`,
          color: `${palette.text.heading} !important`,
        },
      },
      '& .hero-home-button': {
        backgroundColor: 'transparent !important',
        border: `1px solid ${palette.background.ribbon} !important`,
        color: `${palette.text.highlight} !important`,
        paddingBlock: '11px !important',
        '&:hover': {
          backgroundColor: `${palette.secondary.light} !important`,
          borderColor: `${palette.text.highlight} !important`,
          color: `${palette.text.highlight} !important`,
        },
      },

      '& h1,& h2,& h3,& h4,& p': {
        color: palette.text.highlight,
      },
    },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
      },
      '& .MuiSwitch-track': {
        border: 'none',
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      position: 'relative',
      overflow: 'hidden',
      backgroundColor: `${palette.background.fill} !important`,
      backgroundSize: 'cover !important',
      minHeight: 808,
      paddingTop: '88px !important',
      justifyContent: 'center',

      '& .hero-background': {
        width: '100% !important',
        height: '100% !important',
        objectFit: 'cover !important',
        objectPosition: 'center center',
        display: 'block',
      },

      '& .hero-section': {
        height: 'auto !important',
        paddingBottom: '0 !important',
      },
      '& .section-alternate__content': {
        paddingTop: '0 !important',
        paddingBottom: '0 !important',
        '@media (min-width: 1025px)': {
          paddingLeft: '56px !important',
        },
      },
      '& .section-header': {
        marginTop: '0 !important',
      },
      '& .MuiGrid-container > .MuiGrid-item': {
        minHeight: 'unset !important',
      },
      '& [data-aos]': {
        transform: 'none !important',
        opacity: '1 !important',
      },
      '& .section-header__title-wrapper': {
        maxWidth: '640px !important',
      },

      '& .hero-title, & .home-hero-title': {
        fontFamily: 'Editorial New',
        fontSize: '72px !important',
        fontWeight: '500 !important',
        lineHeight: '80px !important',
        letterSpacing: '-0.04em !important',
        color: `${palette.text.highlight} !important`,
        maxWidth: '640px !important',
      },
      '& .header-text': {
        color: `${palette.text.highlight} !important`,
        fontWeight: '500 !important',
      },

      '& .hero-subtitle, & .home-hero-subtitle': {
        fontFamily: 'Inter Display',
        fontSize: '20px !important',
        fontWeight: '400 !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.04em !important',
        color: `${palette.text.highlight} !important`,
        maxWidth: '596px !important',
        '&.MuiTypography-alignLeft': {
          textAlign: 'inherit',
        },
      },

      '& .section-header__subtitle-wrapper': {
        paddingTop: '16px !important',
      },
      '& .section-header__cta-wrapper': {
        paddingTop: '8px !important',
      },
      '& .section-header__cta-item-wrapper': {
        gap: '20px !important',
      },

      '& .section-header__cta-wrapper .MuiButton-root': {
        fontFamily: 'Inter Display',
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.02em !important',
        textTransform: 'none',
        borderRadius: '999px !important',
        padding: '12px 24px !important',
        minHeight: '48px !important',
        boxShadow: 'none !important',
      },
      '& .hero-link-button': {
        backgroundColor: `${palette.text.highlight} !important`,
        color: `${palette.surface.heroCta} !important`,
        border: 'none !important',
        transition: 'background-color 0.2s ease',
        '&:hover': {
          backgroundColor: `${palette.surface.heroCtaHover} !important`,
        },
      },
      '& .login-button': {
        backgroundColor: `${palette.secondary.light} !important`,
        border: `1px solid ${palette.text.highlight} !important`,
        color: `${palette.text.highlight} !important`,
        padding: '12px 32px !important',
        marginLeft: '0 !important',
        transition: 'background-color 0.2s ease, color 0.2s ease',
        '&:hover': {
          backgroundColor: `${palette.text.highlight} !important`,
          color: `${palette.surface.heroCta} !important`,
        },
      },

      '@media (min-width: 1025px) and (max-width: 1439px)': {
        minHeight: 688,
        '& .hero-title, & .home-hero-title': {
          fontSize: '56px !important',
          lineHeight: '62px !important',
        },
        '& .hero-subtitle, & .home-hero-subtitle': {
          fontSize: '18px !important',
          lineHeight: '26px !important',
        },
      },

      [TABLET_DOWN]: {
        minHeight: 'unset !important',
        maxHeight: 'none !important',
        flexDirection: 'column-reverse',
        paddingTop: '112px !important',
        paddingBottom: '0 !important',
        '& .hero-background': {
          display: 'none !important',
        },
        '&::before': {
          content: '""',
          display: 'block',
          width: '100%',
          aspectRatio: '906 / 960',
          background: `url('${HERO_TABLET_IMAGE}') center center / cover no-repeat`,
        },
        '& .MuiGrid-grid-md-6, & .MuiGrid-item': {
          maxWidth: '100% !important',
          flexBasis: '100% !important',
        },
        '& .home-hero-pretitle-stack, & .section-header, & .section-header__title-wrapper, & .section-header__subtitle-wrapper': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
        },
        '& .hero-title, & .home-hero-title, & .hero-subtitle, & .home-hero-subtitle, & .section-header__subtitle': {
          textAlign: 'center !important',
          marginLeft: 'auto !important',
          marginRight: 'auto !important',
        },
        '& .hero-title, & .home-hero-title': {
          fontSize: '48px !important',
          lineHeight: '54px !important',
          maxWidth: '560px !important',
        },
        '& .hero-subtitle, & .home-hero-subtitle': {
          fontSize: '18px !important',
          lineHeight: '26px !important',
          maxWidth: '520px !important',
        },
        '& .section-header__cta-wrapper, & .section-header__cta-container': {
          display: 'flex',
          justifyContent: 'center',
        },
        '& .section-header__cta-item-wrapper': {
          width: 'auto !important',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'center',
        },
      },

      [MOBILE_DOWN]: {
        minHeight: `calc(${HEADER_OFFSET} + 746 * ${HERO_MOBILE_UNIT}) !important`,
        flexDirection: 'column',
        justifyContent: 'flex-start !important',
        paddingTop: `calc(${HEADER_OFFSET} + 56 * ${HERO_MOBILE_UNIT}) !important`,
        backgroundImage: [
          `linear-gradient(to bottom, ${palette.background.heroVeil} 0px,`
            + ` ${palette.background.heroVeil} calc(${HEADER_OFFSET} + 325 * ${HERO_MOBILE_UNIT}),`
            + ` ${palette.background.heroVeilFade} calc(${HEADER_OFFSET} + 540 * ${HERO_MOBILE_UNIT}))`,
          `url('${HERO_MOBILE_IMAGE}')`,
        ].join(', ') + ' !important',
        backgroundSize: 'auto, 100% auto !important',
        backgroundPosition: `center top, center ${HEADER_OFFSET} !important`,
        backgroundRepeat: 'no-repeat, no-repeat !important',
        '&::before': {
          display: 'none !important',
        },
        '& .section-alternate': {
          paddingLeft: `calc(19 * ${HERO_MOBILE_UNIT}) !important`,
          paddingRight: `calc(19 * ${HERO_MOBILE_UNIT}) !important`,
        },
        '& .section-alternate__content': {
          paddingLeft: '0 !important',
          paddingRight: '0 !important',
        },
        '& .section-header__title-wrapper': {
          padding: '0 !important',
        },
        '& .hero-title, & .home-hero-title': {
          fontSize: `calc(48 * ${HERO_MOBILE_UNIT}) !important`,
          lineHeight: `calc(56 * ${HERO_MOBILE_UNIT}) !important`,
          letterSpacing: '-0.05em !important',
          maxWidth: 'none !important',
        },
        '& .section-header__subtitle-wrapper': {
          paddingTop: `calc(24 * ${HERO_MOBILE_UNIT}) !important`,
          paddingBottom: '0 !important',
        },
        '& .hero-subtitle, & .home-hero-subtitle': {
          fontSize: `calc(18 * ${HERO_MOBILE_UNIT}) !important`,
          lineHeight: `calc(28 * ${HERO_MOBILE_UNIT}) !important`,
          maxWidth: 'none !important',
        },
        '& .section-header__cta-wrapper': {
          paddingTop: `calc(32 * ${HERO_MOBILE_UNIT}) !important`,
          marginTop: '0 !important',
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      backgroundColor: `${palette.background.sectionCream} !important`,
      counterReset: 'apex-benefit',

      '& .section-alternate': {
        padding: '0 !important',
      },
      '& .section-alternate__content': {
        padding: '96px !important',
        maxWidth: 'none !important',
      },

      '& .section-header': {
        marginTop: '0 !important',
        marginBottom: '0 !important',
      },
      '& .section-header__title-wrapper': {
        padding: '0 !important',
      },
      '& .section-header__title': {
        fontFamily: 'Editorial New',
        fontWeight: '500 !important',
        fontSize: '48px !important',
        lineHeight: '56px !important',
        letterSpacing: '-0.04em !important',
        color: `${palette.text.benefitsHeading} !important`,
        textAlign: 'left !important',
        paddingBottom: '0 !important',
      },

      '& .definition-services-grid': {
        display: 'grid !important',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 32,
        paddingTop: '40px !important',
        margin: '0 !important',
        width: '100% !important',
        [TABLET_DOWN]: {
          gridTemplateColumns: '1fr',
        },
      },
      '& .definition-service-tile': {
        padding: '0 !important',
        maxWidth: 'none !important',
        flexBasis: 'auto !important',
        display: 'flex',
        counterIncrement: 'apex-benefit',
      },

      '& .MuiCard-root': {
        width: '100%',
        maxHeight: 'none !important',
        backgroundColor: `${palette.surface.benefitsCard} !important`,
        border: `1px solid ${palette.background.ribbon}`,
        borderRadius: '24px !important',
        boxShadow: 'none !important',
      },
      '& .MuiCardContent-root': {
        padding: '48px 32px !important',
        '&:last-child': {
          paddingBottom: '48px !important',
        },
      },
      '& .MuiCardContent-root::before': {
        content: 'counter(apex-benefit, decimal-leading-zero)',
        display: 'block',
        fontFamily: 'Editorial New',
        fontWeight: 500,
        fontSize: 56,
        lineHeight: 1,
        letterSpacing: '-0.04em',
        color: palette.text.benefitsHeading,
        opacity: 0.2,
        marginBottom: 32,
      },

      '& .definition-service-header': {
        marginBottom: '0 !important',
        justifyContent: 'flex-start',
        '& .image': {
          display: 'none !important',
        },
      },
      '& .definition-service-title': {
        fontFamily: 'Editorial New',
        fontWeight: '400 !important',
        fontSize: '28px !important',
        lineHeight: '32px !important',
        letterSpacing: '-0.04em !important',
        color: `${palette.text.benefitsHeading} !important`,
        textAlign: 'left !important',
        paddingBottom: '0 !important',
      },
      '& .definition-service-description': {
        fontFamily: 'Inter Display',
        fontWeight: '400 !important',
        fontSize: '16px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.02em !important',
        color: `${palette.text.benefitssubtitle} !important`,
        textAlign: 'left !important',
        marginBottom: '0 !important',
        paddingBottom: '0 !important',
        borderBottom: 'none !important',
      },

      '& [data-aos]': {
        transform: 'none !important',
        opacity: '1 !important',
      },

      '@media (max-width: 1279px)': {
        '& .section-alternate__content': {
          padding: '72px 40px !important',
        },
        '& .section-header__title': {
          fontSize: '40px !important',
          lineHeight: '48px !important',
        },
      },
      '@media (max-width: 599px)': {
        '& .section-alternate__content': {
          padding: '48px 20px !important',
        },
        '& .section-header__title': {
          fontSize: '32px !important',
          lineHeight: '40px !important',
        },
        '& .MuiCardContent-root': {
          padding: '32px 24px !important',
          '&:last-child': {
            paddingBottom: '32px !important',
          },
        },
        '& .MuiCardContent-root::before': {
          fontSize: 44,
          marginBottom: 28,
        },
        '& .definition-service-title': {
          fontSize: '24px !important',
          lineHeight: '28px !important',
        },
      },
    },

    '& .membership-value-wrapper': {
      backgroundColor: `${palette.background.disclaimerBand} !important`,
      '& .membership-value-section': {
        padding: '56px 96px !important',
        maxWidth: 'none !important',
        [TABLET_DOWN]: {
          padding: '40px !important',
        },
        [MOBILE_DOWN]: {
          padding: '40px 20px !important',
        },
      },
      '& .membership-value-content-wrapper': {
        maxWidth: 1524,
        padding: 0,
      },
      '& .membership-value-header': {
        margin: 0,
        maxWidth: 'none',
      },
      '& .membership-value-title': {
        fontFamily: 'Editorial New',
        fontWeight: 500,
        fontSize: 36,
        lineHeight: '56px',
        letterSpacing: '-1.44px',
        color: palette.background.sectionCream,
        [MOBILE_DOWN]: {
          fontSize: 28,
          lineHeight: '36px',
          letterSpacing: '-1.12px',
        },
      },
      '& .membership-value-subtitle': {
        fontFamily: 'Inter Display',
        fontWeight: 500,
        fontSize: 22,
        lineHeight: '28px',
        letterSpacing: '-0.44px',
        color: palette.secondary.main,
        opacity: 0.8,
        maxWidth: 'none',
        margin: '8px 0 0',
        [MOBILE_DOWN]: {
          fontSize: 16,
          lineHeight: '24px',
        },
      },
      '& .membership-value-layout': {
        display: 'none',
      },
    },

    '& .freebie-section': {
      position: 'relative',
      overflow: 'hidden',
      backgroundColor: `${palette.background.pricingbenefits} !important`,
      lineHeight: 0,

      '& .section': {
        padding: '0 !important',
        maxWidth: 'none !important',
      },
      '& .freebie-container': {
        margin: '0 !important',
        width: '100% !important',
      },
      '& .cover-image-wrapper': {
        padding: '0 !important',
        maxWidth: '100% !important',
        flexBasis: '100% !important',
      },
      '& .freebie-wrapper-right': {
        display: 'none !important',
      },
      '& .freebie-cover-image': {
        display: 'block',
        width: '100% !important',
        height: 'auto !important',
        objectFit: 'cover !important',
        objectPosition: 'center center',
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        bottom: -1,
        width: '100%',
        height: 'clamp(60px, 6.25vw, 120px)',
        backgroundColor: palette.background.pricingbenefits,
        maskImage: `url('${WAVE_BAND}')`,
        maskSize: '100% 100%',
        maskRepeat: 'no-repeat',
        WebkitMaskImage: `url('${WAVE_BAND}')`,
        WebkitMaskSize: '100% 100%',
        WebkitMaskRepeat: 'no-repeat',
        pointerEvents: 'none',
        zIndex: 2,
      },
      '& [data-aos]': {
        transform: 'none !important',
        opacity: '1 !important',
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      position: 'relative',
      backgroundColor: palette.background.pricingbenefits,
      paddingBottom: '96px',
      '@media screen and (max-width: 599px)': {
        paddingBottom: '56px',
      },
      '& [data-aos]': {
        transform: 'none !important',
        opacity: '1 !important',
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: -1,
        left: 0,
        width: '100%',
        height: 'clamp(66px, 6.8vw, 130px)',
        backgroundColor: palette.background.sectionCream,
        maskImage: `url('${WAVE_DOME}')`,
        maskSize: '100% 100%',
        maskRepeat: 'no-repeat',
        WebkitMaskImage: `url('${WAVE_DOME}')`,
        WebkitMaskSize: '100% 100%',
        WebkitMaskRepeat: 'no-repeat',
        pointerEvents: 'none',
        zIndex: 2,
      },

      '& .subscription-bg': {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        height: '100% !important',
        background: palette.background.pricingbenefits,
        zIndex: 0,
      },
      '& .subscription-section': {
        position: 'relative',
        zIndex: 1,
      },
      '& .section-header__title, .summary-text, .summary-subtext, .subscription-tabs-label':{
        color: `${palette.text.highlight} !important`,
        fontWeight: '500 !important',
      },
      '& .section-header__title': {
        fontWeight: 500,
        fontSize: '56px !important',
        lineHeight: '64px !important',
        letterSpacing: '-2.24px !important',
        whiteSpace: 'pre-line',
        '@media screen and (max-width: 900px)': {
          fontSize: '44px !important',
          lineHeight: '56px !important',
          letterSpacing: '-1.76px !important',
        },
        '@media screen and (max-width: 700px)': {
          fontSize: '40px !important',
          lineHeight: '44px !important',
          letterSpacing: '-1.6px !important',
        },
      },
      '& .section-header': {
        marginInline: 'auto !important',
      },
      '& .section-header__title-wrapper': {
        paddingBottom: '0 !important',
      },
      '& .section-header__subtitle-wrapper': {
        paddingTop: '12px !important',
      },
      '& .section-header__subtitle': {
        fontWeight: 400,
        fontSize: '20px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.8px !important',
        color: palette.text.highlight,
        whiteSpace: 'pre-line',
        '@media screen and (max-width: 700px)': {
          fontSize: '18px !important',
          fontWeight: '400 !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
      },
      '& .summary-text': {
        fontWeight: 400,
      },
      '& .subscription-tabs': {
        width: 'fit-content !important',
        margin: '0 auto',
        height: '48px !important',
        minHeight: '48px !important',
        boxSizing: 'border-box',
        backgroundColor: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.text.highlight}`,
        borderRadius: '999px !important',
        padding: '0 !important',
        overflow: 'hidden',
        '& .MuiTabs-indicator': {
          display: 'none !important',
        },
        '& .MuiTabs-flexContainer, & .MuiTabs-scroller': {
          backgroundColor: 'transparent !important',
        },
        '& .MuiTab-root': {
          minHeight: '46px !important',
          height: '46px !important',
          minWidth: 'unset !important',
          borderRadius: '999px !important',
          padding: '0 24px !important',
          border: 'none !important',
          textTransform: 'none',
          fontFamily: 'Inter Display',
          fontSize: '16px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.32px !important',
          fontWeight: '500 !important',
          opacity: 1,
          backgroundColor: 'transparent !important',
          color: `${palette.text.heading} !important`,
          transition: 'background-color 0.2s ease, color 0.2s ease',
        },
        '& .MuiTab-root.Mui-selected': {
          backgroundColor: `${palette.surface.heroCta} !important`,
          color: `${palette.text.highlight} !important`,
          border: 'none !important',
          boxShadow: `0 1px 10px -1px ${palette.shadowXs}`,
        },
      },

      '& .subscription-carousel-wrapper': {
        marginTop: '44px !important',
      },
      [TABLET_DOWN]: {
        '& .subscription-plan-card-item': {
          maxWidth: '100% !important',
          flexBasis: '100% !important',
          display: 'flex',
          justifyContent: 'center',
        },
      },

      '& #pricing-benefit-section': {
        '& .planCard': {
          fontWeight: 400,
          fontSize: '16px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.32px !important',
          border: 'none !important',
          borderRadius: '12px !important',
          boxShadow: 'none !important',
          '&:hover': {
            border: 'none !important',
            color: palette.text.primary,
            background: palette.text.highlight,
            '& hr': {
              backgroundColor: `${palette.divider} !important`,
            },
            // Do not lock button colors here — allows Get Started :hover darken
          },
          '& .customGetStarted': {
            borderRadius: '999px !important',
            width: '100% !important',
            height: '48px !important',
            padding: '12px 20px !important',
            fontSize: '16px !important',
            lineHeight: '20px !important',
            letterSpacing: '-0.32px !important',
            textTransform: 'none',
            transition:
              'background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease',
            '& .MuiButton-label': {
              fontSize: '16px !important',
              lineHeight: '20px !important',
            },
          },
          '& .customGetStarted.MuiButton-outlined, & .customGetStarted.MuiButton-outlinedPrimary': {
            backgroundColor: 'transparent !important',
            border: `1px solid ${palette.surface.heroCta} !important`,
            color: `${palette.surface.heroCta} !important`,
          },
          '& .customGetStarted.MuiButton-contained, & .customGetStarted.MuiButton-containedPrimary': {
            backgroundColor: `${palette.surface.heroCta} !important`,
            border: `1px solid ${palette.surface.heroCta} !important`,
            color: `${palette.text.highlight} !important`,
          },
          '& .customGetStarted:hover, & .customGetStarted:focus, &:hover .customGetStarted:hover': {
            backgroundColor: `${palette.text.benefitsHeading} !important`,
            border: `1px solid ${palette.text.benefitsHeading} !important`,
            color: `${palette.text.highlight} !important`,
          },
          '& .customcardTitle': {
            fontWeight: 500,
            fontSize: '24px !important',
            lineHeight: '28px !important',
            letterSpacing: '-0.96px !important',
            color: `${palette.text.heading} !important`,
          },
          '& .price-value': {
            fontWeight: 500,
            fontSize: '28px !important',
            lineHeight: '32px !important',
            letterSpacing: '-1.12px !important',
            color: `${palette.text.heading} !important`,
            '@media screen and (max-width: 700px)': {
              fontSize: '24px !important',
              lineHeight: '28px !important',
              letterSpacing: '-0.96px !important',
            },
          },
          '& .price-frequency': {
            fontFamily: 'Inter Display',
            fontSize: '14px !important',
            lineHeight: '18px !important',
            letterSpacing: '-0.28px !important',
            color: `${palette.text.benefitssubtitle} !important`,
          },
          '& .customSubscriberName': {
            fontFamily: 'Inter Display',
            fontSize: '13px !important',
            lineHeight: '16px !important',
            letterSpacing: '-0.39px !important',
            color: `${palette.text.benefitssubtitle} !important`,
          },
          '& .bold': {
            fontFamily: 'Editorial New',
            fontSize: '20px !important',
            lineHeight: '20px !important',
            letterSpacing: '-0.4px !important',
            color: `${palette.text.benefitssubtitle} !important`,
          },
          '& .cptCodes': {
            fontFamily: 'Inter Display',
            fontSize: '14px !important',
            lineHeight: '18px !important',
            letterSpacing: '-0.28px !important',
          },
          '& .customUpfrontWrapper': {
            color: palette.text.tertiaryLight,
            fontWeight: 400,
            fontSize: '14px !important',
            lineHeight: '20px !important',
            letterSpacing: '-0.42px !important',
            fontStyle: 'italic',
            // $amount uses .bold (shared with "What's Included" 18px) — keep disclaimer at 14px
            '& .bold, & .disclaimerText, & .MuiTypography-root': {
              fontSize: '14px !important',
              lineHeight: '20px !important',
              fontWeight: 400,
              fontStyle: 'italic',
              color: `${palette.text.tertiaryLight} !important`,
            },
          },
        },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px 0px 32px',
            },
            '@media(max-width: 900px)': {
              margin: '0px 0px 32px',
            },
          },
          '& .plans-loader': {
            color: palette.text.highlight,
          },
        },
        '& .bold': {
          fontWeight: 500,
          fontSize: '18px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
          color: `${palette.text.secondary} !important`,
          '@media screen and (max-width: 700px)': {
            fontSize: '18px !important',
            lineHeight: '22px !important',
          },
        },
        '& .summary-text, & .summary-subtext': {
          fontFamily: 'Inter Display',
          fontWeight: '400 !important',
          fontSize: '20px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.8px !important',
          color: `${palette.text.highlight} !important`,
        },
        '& .savings-summary-link': {
          color: `${palette.text.highlight} !important`,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: `${palette.background.sectionCream} !important`,
      paddingTop: '80px',
      paddingBottom: '96px',

      '& .section': {
        maxWidth: 'none !important',
        paddingBlock: '0 !important',
        paddingInline: `${CONTENT_BAND_INSET} !important`,
        '@media(max-width: 600px)': {
          paddingInline: '20px !important',
        },
      },
      '& .howitworks-wrapper': {
        padding: '0 !important',
      },

      '& .howitworks-title': {
        padding: '0 !important',
        marginBottom: 56,
        '& .section-header': {
          marginTop: '0 !important',
          marginBottom: '0 !important',
        },
        '& .section-header__title-wrapper': {
          padding: '0 !important',
        },
        '& .section-header__subtitle-wrapper': {
          paddingTop: '12px !important',
          paddingBottom: '0 !important',
        },
        '& .section-header__title': {
          fontFamily: 'Editorial New',
          whiteSpace: 'pre-line',
          fontSize: '48px !important',
          lineHeight: '56px !important',
          letterSpacing: '-0.04em !important',
          color: `${palette.text.heading} !important`,
          fontWeight: '500 !important',
          '@media screen and (max-width: 900px)': {
            fontSize: '40px !important',
            lineHeight: '48px !important',
          },
          '@media screen and (max-width: 599px)': {
            fontSize: '32px !important',
            lineHeight: '40px !important',
          },
        },
        '& .section-header__subtitle': {
          fontFamily: 'Inter Display',
          fontWeight: 400,
          fontSize: '20px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.02em !important',
          color: `${palette.text.benefitssubtitle} !important`,
          '@media screen and (max-width: 900px)': {
            fontSize: '18px !important',
            lineHeight: '26px !important',
          },
        },
      },

      '& .howitworks-wrapper > .MuiGrid-container': {
        display: 'grid !important',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 40,
        margin: '0 !important',
        width: '100% !important',
        '@media screen and (max-width: 899px)': {
          gridTemplateColumns: '1fr',
        },
      },
      '& .howitworks-wrapper > .MuiGrid-container > .MuiGrid-item': {
        padding: '0 !important',
        maxWidth: 'none !important',
        flexBasis: 'auto !important',
      },

      '& .cover-image-wrapper': {
        marginBottom: 40,
        '& .how-it-works-image': {
          borderRadius: 24,
          display: 'block',
          width: '100% !important',
          height: 'auto !important',
          aspectRatio: '1 / 1',
          objectFit: 'cover !important',
        },
      },
      '& .step-subtitle-wrapper': {
        marginTop: 12,
      },

      '& .working-steps-container': {
        margin: '0 !important',
        width: '100% !important',
        '& > .MuiGrid-item': {
          padding: '0 !important',
        },
        '& .step-title': {
          fontFamily: 'Editorial New',
          fontSize: '24px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.04em !important',
          fontWeight: '500 !important',
          color: `${palette.text.heading} !important`,
          paddingBottom: '0 !important',
          '@media screen and (max-width: 900px)': {
            fontSize: '22px !important',
            lineHeight: '26px !important',
          },
        },
        '& .step-content': {
          fontFamily: 'Inter Display',
          fontSize: '18px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.03em !important',
          fontWeight: 400,
          color: `${palette.text.benefitssubtitle} !important`,
          '@media screen and (max-width: 900px)': {
            fontSize: '16px !important',
            lineHeight: '22px !important',
          },
        },
      },

      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: palette.background.stepcounter,
        color: palette.secondary.main,
        fontSize: 15,
      },
      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },
      '& [data-aos]': {
        transform: 'none !important',
        opacity: '1 !important',
      },

      '@media screen and (max-width: 899px)': {
        paddingTop: '48px',
        paddingBottom: '56px',
        '& .howitworks-title': {
          marginBottom: 40,
          '& .section-header__title, & .section-header__subtitle': {
            textAlign: 'center !important',
          },
        },
        '& .cover-image-wrapper': {
          marginBottom: 24,
        },
      },
    },

    '& .FAQSection': {
      backgroundColor: palette.background.sectionVeil,
      paddingBlock: '96px 32px !important',
      paddingInline: `${CONTENT_BAND_INSET} !important`,
      maxWidth: 'none !important',

      '& .faq-variant2-wrapper': {
        paddingBottom: 96,
        borderBottom: `1px solid ${palette.background.ribbon}`,
      },

      '& .faq-variant2-wrapper > .MuiGrid-container': {
        display: 'grid !important',
        gridTemplateColumns: '380px 1fr',
        gap: 80,
        margin: '0 !important',
        width: '100% !important',
        alignItems: 'start',
        [TABLET_DOWN]: {
          gridTemplateColumns: '1fr',
          gap: 40,
        },
      },
      '& .faq-variant2-wrapper > .MuiGrid-container > .MuiGrid-item': {
        padding: '0 !important',
        maxWidth: 'none !important',
        flexBasis: 'auto !important',
      },

      '& .section-header': {
        margin: '0 !important',
        width: '100% !important',
      },
      '& .section-header__title-wrapper': {
        order: 1,
        padding: '0 !important',
      },
      '& .section-header__title': {
        fontFamily: 'Editorial New',
        fontSize: '48px !important',
        lineHeight: '56px !important',
        letterSpacing: '-0.04em !important',
        fontWeight: '500 !important',
        color: `${palette.text.heading} !important`,
        textAlign: 'left !important',
        [TABLET_DOWN]: {
          fontSize: '40px !important',
          lineHeight: '48px !important',
        },
        '@media screen and (max-width: 599px)': {
          fontSize: '32px !important',
          lineHeight: '40px !important',
        },
      },
      '& .section-header__overline-wrapper': {
        order: 2,
        padding: '12px 0 0 !important',
        fontFamily: 'Inter Display',
        fontSize: '20px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.04em !important',
        fontWeight: 400,
        color: `${palette.text.benefitssubtitle} !important`,
        textAlign: 'left !important',
        [TABLET_DOWN]: {
          fontSize: '18px !important',
          lineHeight: '26px !important',
        },
      },

      '& .MuiBox-root': {
        marginTop: '32px !important',
        marginBottom: '0 !important',
      },
      '& .viewAllFaqButton, & .MuiButton-containedPrimary': {
        backgroundColor: `${palette.surface.heroCta} !important`,
        color: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.surface.heroCta} !important`,
        borderRadius: '999px !important',
        minHeight: '56px !important',
        padding: '12px 32px !important',
        boxShadow: 'none !important',
        textTransform: 'none',
        fontFamily: 'Inter Display',
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.02em !important',
        fontWeight: '500 !important',
        '&:hover': {
          backgroundColor: `${palette.text.benefitsHeading} !important`,
          borderColor: `${palette.text.benefitsHeading} !important`,
        },
      },

      '& .faq-questions': {
        width: '100% !important',
      },
      '& .faq-questions-grid': {
        margin: '0 !important',
        width: '100% !important',
      },
      '& .faq-questions-panels': {
        padding: '0 !important',
        maxWidth: '100% !important',
        flexBasis: '100% !important',
        '& .MuiGrid-container, & .MuiGrid-item': {
          margin: '0 !important',
          width: '100% !important',
          maxWidth: '100% !important',
          padding: '0 !important',
        },
      },
      '& .accordion': {
        width: '100% !important',
      },

      '& .accordion__item-wrapper': {
        backgroundColor: 'transparent !important',
        boxShadow: 'none !important',
        margin: '0 !important',
        border: 'none !important',
        borderRadius: '0 !important',
        '&:before': {
          display: 'none',
        },
        '&:not(:last-child)': {
          paddingBottom: '32px !important',
          marginBottom: '32px !important',
          borderBottom: `1px solid ${palette.background.ribbon} !important`,
        },
      },
      '& .MuiAccordionSummary-root': {
        padding: '0 !important',
        minHeight: 'unset !important',
        '&.Mui-expanded': {
          minHeight: 'unset !important',
        },
      },
      '& .MuiAccordionSummary-content': {
        margin: '0 !important',
        '&.Mui-expanded': {
          margin: '0 !important',
        },
      },
      '& .accorion__item-title-container .MuiTypography-root': {
        fontFamily: 'Inter Display',
        fontSize: '20px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.04em !important',
        fontWeight: '500 !important',
        color: `${palette.text.heading} !important`,
        paddingRight: 48,
        '@media screen and (max-width: 599px)': {
          fontSize: '18px !important',
          lineHeight: '26px !important',
        },
      },
      '& .MuiAccordionSummary-expandIcon': {
        padding: '0 !important',
        marginRight: '0 !important',
        color: `${palette.text.heading} !important`,
        '& .MuiSvgIcon-root': {
          width: 24,
          height: 24,
          color: `${palette.text.heading} !important`,
        },
        '&.Mui-expanded': {
          transform: 'none !important',
        },
      },
      '& .MuiAccordionDetails-root': {
        padding: '24px 64px 0 0 !important',
        fontFamily: 'Inter Display',
        fontSize: '14px !important',
        lineHeight: '18px !important',
        letterSpacing: '-0.28px !important',
        fontWeight: 400,
        color: `${palette.text.benefitssubtitle} !important`,
        '& *': {
          fontFamily: 'Inter Display',
          fontSize: '14px !important',
          lineHeight: '18px !important',
          letterSpacing: '-0.28px !important',
          fontWeight: 400,
          color: `${palette.text.benefitssubtitle} !important`,
        },
      },

      '& [data-aos]': {
        transform: 'none !important',
        opacity: '1 !important',
      },

      [TABLET_DOWN]: {
        paddingBlock: '64px 24px !important',
        paddingInline: '40px !important',
        '& .faq-variant2-wrapper': {
          paddingBottom: 56,
        },
      },
      '@media screen and (max-width: 599px)': {
        paddingBlock: '48px 24px !important',
        paddingInline: '20px !important',
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .section-header': {
        '& .hero-header-title': {
          fontSize: '36px !important',
          lineHeight: '40px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 400,
          '@media screen and (max-width: 900px)': {
            fontSize: '32px !important',
            lineHeight: '36px !important',
            letterSpacing: '-0.64px !important',
          },
        },
        '& .hero-header-subtitle': {
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: 400,
        },
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.secondary.main} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        padding: '0px 0px 0px 0px !important',
        backgroundColor: palette.background.primary,
      },

      '& .footer-bar': {
        backgroundColor: `${palette.primary.main} !important`,
      },

      '& .footer-bar-text': {
        color: palette.text.highlight,
      },
      '& .MuiButton-containedSecondary': {
        backgroundColor: palette.primary.light,
        color: palette.text.highlight,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      position: 'relative',
      backgroundColor: palette.background.sectionVeil,
      paddingBlock: '32px 72px',
      paddingInline: CONTENT_BAND_INSET,

      '& .hero-static-bg': {
        display: 'none !important',
      },
      '& .hero-static-section': {
        backgroundColor: `${palette.surface.heroCta} !important`,
        borderRadius: 24,
        padding: '64px !important',
        margin: '0 !important',
        maxWidth: 'none !important',
        width: '100%',
        height: 'auto !important',
        display: 'block !important',
      },
      '& .section-alternate__content': {
        padding: '0 !important',
        maxWidth: 'none !important',
      },
      '& .hero-static-section-grid': {
        margin: '0 !important',
        width: '100% !important',
        '& > .MuiGrid-item': {
          padding: '0 !important',
        },
      },
      '& .section-header': {
        margin: '0 !important',
      },
      '& .section-header__title-wrapper': {
        padding: '0 !important',
      },
      '& .section-header__subtitle-wrapper': {
        padding: '12px 0 0 !important',
      },
      '& .section-header__title': {
        fontFamily: 'Editorial New',
        color: `${palette.text.highlight} !important`,
        fontWeight: '500 !important',
        fontSize: '36px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.04em !important',
        textAlign: 'left !important',
        [TABLET_DOWN]: {
          fontSize: '30px !important',
          lineHeight: '36px !important',
          textAlign: 'center !important',
        },
      },
      '& .section-header__subtitle': {
        fontFamily: 'Inter Display',
        color: `${palette.text.highlight} !important`,
        opacity: 0.8,
        fontWeight: '400 !important',
        fontSize: '20px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.04em !important',
        textAlign: 'left !important',
        [TABLET_DOWN]: {
          fontSize: '18px !important',
          lineHeight: '26px !important',
          textAlign: 'center !important',
        },
      },
      '& .hero-button-wrapper': {
        justifyContent: 'flex-end !important',
        [TABLET_DOWN]: {
          justifyContent: 'center !important',
          marginTop: 32,
        },
      },
      '& .primary-static-button': {
        backgroundColor: `${palette.text.highlight} !important`,
        color: `${palette.surface.heroCta} !important`,
        border: 'none !important',
        borderRadius: '999px !important',
        minHeight: '56px !important',
        padding: '12px 32px !important',
        boxShadow: 'none !important',
        textTransform: 'none',
        fontFamily: 'Inter Display',
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.02em !important',
        fontWeight: '500 !important',
        whiteSpace: 'nowrap',
        '&:hover': {
          backgroundColor: `${palette.surface.heroCtaHover} !important`,
          color: `${palette.surface.heroCta} !important`,
        },
      },

      '& [data-aos]': {
        transform: 'none !important',
        opacity: '1 !important',
      },

      [TABLET_DOWN]: {
        paddingBlock: '24px 56px',
        paddingInline: '40px',
        '& .hero-static-section': {
          padding: '40px !important',
        },
      },
      '@media screen and (max-width: 599px)': {
        paddingBlock: '24px 48px',
        paddingInline: '20px',
        '& .hero-static-section': {
          padding: '32px 24px !important',
        },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .hero-header-title': {
        fontSize: '48px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.96px !important',
        fontWeight: 400,
      },
      '& .hero-header-subtitle': {
        fontSize: '16px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 500,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        background: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.primary.main} !important`,
      },
    },

    '& .checkout-flow-main-container': {
      '& .card-wrapper': {
        '& .MuiTypography-root, .MuiButton-label': {
          fontSize: '18px !important',
        },
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .hero-header-title, & .hero-header-subtitle': {
        margin: '0',
        maxWidth: 'unset',
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '10px',
          padding: '64px 24px !important',
          paddingBottom: '0px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .faq-link': {
        fontSize: '15px !important',
      },
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.primary,
      },
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.32px !important',
        fontWeight: 400,
      },
      '& .accorion__item-title-container': {
        '& .MuiTypography-subtitle1': {
          fontSize: '18px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 500,
        },
      },
    },
    '& .faq-contact-section': {
      background: `${palette.background.primary} !important`,
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      paddingInline: '80px !important',
      color: 'palette.text.tertiary !important',
      '@media screen and (min-width: 1024px)': {
        paddingInline: '0px !important',
      },
      '@media(max-width: 1024px)': {
        paddingInline: '30px !important',
      },
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
      '& .contact-card-title': {
        fontSize: '32px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 400,
      },
      '& .contact-card-subtitle': {
        fontSize: '18px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        fontWeight: 400,
      },
      '& .provider-contact-details': {
        fontSize: '16px !important',
        lineHeight: '18px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 400,
        paddingBottom: '8px !important',
      },
      '& .provider-contact-link': {
        fontSize: '18px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        fontWeight: 500,
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
        maxWidth: '100%',
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .MuiGrid-container': {
        padding: '12px',
      },
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'none',
        fontWeight: 'bold',
      },
    },

    '& .success-wrapper': {
      marginTop: 120,
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.surface.grey,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
      backgroundColor: palette.background.tableHead,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      maxWidth: '598px',
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.surface.light,
      },
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.surface.light,
        color: palette.surface.light,
      },
    },

    // Stepper Icon Styles - Completed vs Uncompleted
    '& .MuiStepIcon-root': {
      color: 'transparent', // Default: transparent background
      width: 32,
      height: 32,
      borderColor: palette.primary.main,

      // Completed step - filled circle with checkmark
      '&.MuiStepIcon-completed': {
        fill: `${palette.primary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
      },

      // Active step - filled circle with number
      '&.MuiStepIcon-active': {
        fill: `${palette.primary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.highlight, // White text on filled background
        },
      },

      // Uncompleted step - empty circle with number
      '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.primary.main, // Dark text on transparent background
        },
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,

      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 500,
      },

      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 500,
      },
    },

    // Stepper Connector Line
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: `${palette.primary.main} !important`,
      borderTopWidth: 2,
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      }
    },

    '& .stepperItems': {
      marginTop: 24,
    },

    '& .footer-top-banner': {
      padding: '12px 20px',
      backgroundColor: palette.background.disclaimerBand,
      color: palette.background.sectionCream,
      fontFamily: 'Editorial New',
      fontWeight: 500,
      fontSize: 24,
      lineHeight: '31px',
      letterSpacing: '-0.96px',
      [MOBILE_DOWN]: {
        fontSize: 20,
        lineHeight: '26px',
      },
    },

    '& .footer-wrapper': {
      backgroundColor: `${palette.background.footerLight} !important`,
      color: `${palette.text.heading} !important`,
      paddingInline: '96px !important',
      '& a, & button, & b, & span, & p, & .footer-link, & .copyrights-footer-link': {
        color: `${palette.text.heading} !important`,
        fontFamily: 'Inter Display',
        fontSize: '14px !important',
        lineHeight: '18px !important',
        letterSpacing: '-0.28px !important',
        fontWeight: '400 !important',
      },
      '& .copyrights-footer': {
        borderTop: `1px solid ${palette.background.footerDivider}`,
      },
      '@media(max-width: 900px)': {
        paddingInline: '40px !important',
      },
      '@media(max-width: 500px)': {
        paddingInline: '20px !important',
      },
    },
    '& .success-wrapper': {
      '& .MuiButton-containedPrimary': {
        backgroundColor: `${palette.text.highlight} !important`,
        color: `${palette.text.black} !important`,
        border: `0.5px solid ${palette.text.black} !important`,
      },
      '& .MuiButton-containedSecondary': {
        backgroundColor: `${palette.primary.main} !important`,
        color: `${palette.text.highlight} !important`,
      },
    },

    '& .header-text': {
      color: palette.primary.light,
      fontWeight: '500 !important',
    },
    '& .checkout-hero-section': {
      '& .section-header__title': {
        fontWeight: '500 !important',
      },
    },
    '& .dashboard-main-container': {
      '& .description-cta': {
        backgroundColor: palette.background.loginhome,
      },
    },

    '& .widget': {
      backgroundColor: palette.background.loginhome,
    },

  },
};
